import { computed, reactive, toRaw } from 'vue'
import { shopSettings } from '../../../../Greativ/shop/settings'

const state = reactive({
  settings: {},
})

export const loadSettings = async () => {
  const { success, settings } = await shopSettings()

  if (success) {
    state.settings = settings
  }

  return {
    success,
  }
}

export const seoByKey = (key) => {
  return computed(() => {
    if (!key) {
      return ''
    }

    if (state.settings.seo && state.settings.seo[key]) {
      return toRaw(state.settings.seo[key])
    }

    return ''
  })
}

export const priceFloat = computed(() => {
  return toRaw(!!state.settings.price_float)
})

export const currency = computed(() => {
  if (state.settings.currency) {
    return toRaw(state.settings.currency)
  }
  return ''
})
